import { msg } from 'gt-react';
import { StorefrontIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  requireModules,
  requirePermission,
  Route as pathlessAuthenticatedRoute,
} from '../route';

const SuppliersPage = lazyRouteComponent(() => import('./SuppliersPage'));

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/suppliers',
  staticData: {
    app: {
      nav: {
        label: msg('Suppliers', {
          context: 'sidebar nav label, Accounts Payable section',
        }),
        icon: <StorefrontIcon className="h-4 w-4" weight="fill" />,
        group: 'Accounts Payable',
        order: 15,
        groupOrder: 40,
      },
      access: {
        modulesAnyOf: [ProductModule.AP_INVOICING],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Supplier }],
      },
    },
  },
  component: SuppliersPage,
  loader: () => ({
    crumb: msg('Suppliers', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [
        ProductModule.AP_INVOICING,
        ProductModule.REBATES,
        ProductModule.PROCUREMENT,
      ],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.Supplier,
    });
  },
  validateSearch: z.object({
    q: z.string().optional(),
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(100).optional(),
    includeInactive: z.boolean().optional(),
  }),
});
